import { createContext, useReducer } from "react";
import questions from "../data/questoes";



let nome = window.prompt('digite seu nome')



if (nome == '' || nome == null || nome.length < 4) {
    do {
        nome = window.prompt('digite seu nome')
    } while (!nome)

    if (nome.length < 4) {
        do {
            nome = window.prompt('digite um nome válido')
        } while (nome.length < 4)
    }
}



var categoria;
var newMinutos;
var newSegundos;

const STAGES = ["Start", "Category", "Playing", "End", "Ranking", "TopDez", "Home", "Niveis",];

const initialState = {
    newMinutos,
    newSegundos,
    categoria,
    nome,
    gameStage: STAGES[0],
    questions,
    currentQuestion: 0,
    answerSelected: false,
    score: 0,
    help: false,
    optionToHide: null,
};

// console.log(initialState);

const quizReducer = (state, action) => {
    switch (action.type) {
        case "CHANGE_STAGE":
            return {
                ...state,
                gameStage: STAGES[1],
            };

        case "START_GAME":
            let quizQuestions = null;

            state.questions.forEach((question) => {
                if (question.category === action.payload) {
                    quizQuestions = question.questions;

                }
            });

            return {
                ...state,
                categoria: action.payload,
                questions: quizQuestions,
                gameStage: STAGES[2],


            };

        case "REORDER_QUESTIONS":
            const reorderedQuestions = state.questions.sort(() => {
                return Math.random() - 0.5;
            });

            return {
                ...state,
                questions: reorderedQuestions,
            };

        case "CHANGE_QUESTION": {
            const nextQuestion = state.currentQuestion + 1;
            let endGame = false;

            if (!state.questions[nextQuestion]) {
                endGame = true;
            }

            return {
                ...state,
                currentQuestion: nextQuestion,
                gameStage: endGame ? STAGES[3] : state.gameStage,
                answerSelected: false,
                help: false,
            };
        }

        case "FINISHI TIMER": {
            const nextQuestion = state.currentQuestion + 6;
            let endGame = false;

            if (!state.questions[nextQuestion]) {
                endGame = true;
            }

            return {
                ...state,
                currentQuestion: nextQuestion,
                gameStage: endGame ? STAGES[3] : state.gameStage,
                answerSelected: false,
                help: false,
            };
        }

        case "NEW_GAME": {
            return initialState;
        }

        case "CHECK_ANSWER": {
            if (state.answerSelected) return state;

            const answer = action.payload.answer;
            const option = action.payload.option;
            let correctAnswer = 0;

            if (answer === option) correctAnswer = 1;

            return {
                ...state,
                score: state.score + correctAnswer,
                answerSelected: option,
            };
        }

        case "SHOW_TIP": {
            return {
                ...state,
                help: "tip",
            };
        }

        case "REMOVE_OPTION": {
            const questionWithoutOption = state.questions[state.currentQuestion];

            // console.log(state.currentQuestion);

            // console.log(questionWithoutOption);

            let repeat = true;
            let optionToHide;

            questionWithoutOption.options.forEach((option) => {
                if (option !== questionWithoutOption.answer && repeat) {
                    optionToHide = option;
                    repeat = false;
                }
            });

            return {
                ...state,
                optionToHide,
                help: true,
            };

        }

        case "Ranking":
            return {
                ...state,
                gameStage: STAGES[4],
            };

        case "TopDez":

            return {
                ...state,
                categoria: action.payload,
                gameStage: STAGES[5],


            };

        case "HOME":
            return {
                ...state,
                gameStage: STAGES[0],
            };

        case "Niveis":
            return {
                ...state,
                gameStage: STAGES[7],
            };


        default:
            return state;
    }
};

export const QuizContext = createContext();

export const QuizProvider = ({ children }) => {
    const value = useReducer(quizReducer, initialState);

    return <QuizContext.Provider value={value}>{children}</QuizContext.Provider>;
};
